"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAmenitiesResponseDto = instanceOfAmenitiesResponseDto;
exports.AmenitiesResponseDtoFromJSON = AmenitiesResponseDtoFromJSON;
exports.AmenitiesResponseDtoFromJSONTyped = AmenitiesResponseDtoFromJSONTyped;
exports.AmenitiesResponseDtoToJSON = AmenitiesResponseDtoToJSON;
exports.AmenitiesResponseDtoToJSONTyped = AmenitiesResponseDtoToJSONTyped;
var AmenityGroupDto_1 = require("./AmenityGroupDto");
/**
 * Check if a given object implements the AmenitiesResponseDto interface.
 */
function instanceOfAmenitiesResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function AmenitiesResponseDtoFromJSON(json) {
    return AmenitiesResponseDtoFromJSONTyped(json, false);
}
function AmenitiesResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (json['data'].map(AmenityGroupDto_1.AmenityGroupDtoFromJSON)),
        'error': json['error'] == null ? undefined : json['error'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function AmenitiesResponseDtoToJSON(json) {
    return AmenitiesResponseDtoToJSONTyped(json, false);
}
function AmenitiesResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : (value['data'].map(AmenityGroupDto_1.AmenityGroupDtoToJSON)),
        'error': value['error'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
